import styled, { css } from 'styled-components'

import { textInputStyles, textInputStylesConfig } from '../../../_constants/styles'
import { S_FormSelect } from '../../Forms/FormInput/FormInput.styles'
import colors from '../../../_constants/colors'

export const S_NoteEditor = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: ${(props) => props.flexType};
  justify-content: ${(props) => (props.flexType === 'row' ? 'space-between ' : '')};
  margin-right: 10px;

  .stat {
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  textarea.limited-width {
    ${textInputStyles}
    width: 240px;
    max-width: 240px; /* prevent text-area overflow*/
    min-width: 240px;
    min-height: ${textInputStylesConfig.minHeight};
  }

  textarea.full-width {
    width: 100%;
    padding: 15px;
    min-height: ${textInputStylesConfig.minHeight};
    margin-top: 8px;
    margin-bottom: 8px;
    border-radius: 5px;
    outline: none;
    border: 1px solid ${colors.OUTLINE_GREY_BOX};
    flex-grow: 1;
  }

  .error {
    color: tomato;
    height: 30px;
  }
  .save-btn {
    float: right;
    margin-left: auto;
  }
  .label {
    margin-bottom: 10px;
    color: ${colors.TEXT_DARK};
    font-weight: 400;
  }
  .type-document {
    display: flex;
    padding: 3px 0;

    button.compact {
      min-width: 116px;
    }

    ${S_FormSelect} {
      flex-grow: 1;
      margin-right: 8px;
    }
  }
`

export const normalizeButtonWidth = css`
  padding: 11px 0;
  min-width: unset;

  & > div {
    width: 116px;
  }
`
export const splitButtonCss = css`
  .btn.btn-main {
    height: 100%;
    min-width: 89px;
  }

  .split-button {
    margin-top: 0;
    height: 100%;
  }

  .btn {
    height: 100%;
  }

  .btn-container {
    height: 100%;
  }

  .btn.btn-dropdown {
    height: 100%;
  }

  .dropdown-menu.open {
    width: 100%;
    li {
      width: 100%;
      div {
        padding: 3px 0;
      }
    }
  }
`
